import React from 'react'
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

// eslint-disable-next-line react/prop-types
export default function NavContextMenu({ children, href }) {
    const [contextMenu, setContextMenu] = React.useState(null);

    const handleContextMenu = (event) => {
        event.preventDefault();
        setContextMenu(
            contextMenu === null
                ? {
                    mouseX: event.clientX + 2,
                    mouseY: event.clientY - 6,
                }
                : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
                // Other native context menus might behave different.
                // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
                null,
        );
    };

    const handleClose = () => {
        setContextMenu(null);
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(href);
            handleClose()
        } catch (err) {
            handleClose()
        }
    }

    const handleOpen = () => {
        const newWindow = window.open(href, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
        handleClose()
    }

    return (
        <div onContextMenu={handleContextMenu} style={{ cursor: 'context-menu' }}>
            {children}
            <Menu
                open={contextMenu !== null}
                onClose={handleClose}
                anchorReference="anchorPosition"
                anchorPosition={
                    contextMenu !== null
                        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                        : undefined
                }
            >
                <MenuItem onClick={handleCopy}>Copy</MenuItem>
                <MenuItem onClick={handleOpen}>Open</MenuItem>
            </Menu>
        </div>
    )
}
